var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45622 1.25884V5.04524C9.23722 7.90644 10.0183 9.68084 8.89835 10.2284C7.56236 10.6769 7.11732 10.388 4.46232 10.466C1.96732 10.5363 0.539147 10.4042 0.43815 9.64984V2.53264C0.523156 1.35864 -0.276725 0.353339 3.34928 0.449639C6.79827 0.51504 9.07621 0.126344 9.45622 1.25884Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5111 1.25884V5.04524C20.2911 7.90644 21.0732 9.68084 19.9522 10.2284C18.6172 10.6769 18.1722 10.388 15.5162 10.466C13.0212 10.5363 11.5943 10.4042 11.4923 9.64984V2.53264C11.5783 1.35864 10.7781 0.353339 14.4041 0.449639C17.8531 0.51504 20.1301 0.126344 20.5111 1.25884Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60075 12.7832V16.5695C9.38176 19.4307 10.1639 21.2051 9.04289 21.7527C7.7079 22.2013 7.26187 21.9123 4.60686 21.9904C2.11186 22.0607 0.684677 21.9285 0.582687 21.1742V14.057C0.667679 12.883 -0.132187 11.8777 3.49382 11.9741C6.94283 12.0394 9.22076 11.6507 9.60075 12.7832Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5111 12.7832V16.5695C20.2911 19.4307 21.0732 21.2051 19.9522 21.7527C18.6172 22.2013 18.1722 21.9123 15.5162 21.9904C13.0212 22.0607 11.5943 21.9285 11.4923 21.1742V14.057C11.5783 12.883 10.7781 11.8777 14.4041 11.9741C17.8531 12.0394 20.1301 11.6507 20.5111 12.7832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashUser);
export default __webpack_public_path__ + "static/media/dash-user.63ac520d14032703957256a78afbcdce.svg";
export { ForwardRef as ReactComponent };